import React, { memo } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Modal, Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { ContactForm } from './index';

const useStyles = makeStyles((theme) => ({
  header: {
    color: '#002d5c',
    width: '100%',
    textAlign: 'center',
    marginBottom: '2rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '875px',
    backgroundColor: '#fff',
    borderRadius: '20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    border: '1px solid #E5EAF4',
    padding: '20px',
    zIndex: 3,
    lineHeight: '0',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  closeButton: {
    position: 'fixed',
    top: '5px',
    right: '5px',
    color: '#FFF',
    zIndex: 1301,
    transition: 'transform 0.7s ease',
    transform: 'rotate(0deg)',
    backgroundColor: 'transparent',
    border: 'none',

    '&:hover': {
      transform: 'rotate(180deg)',
      backgroundColor: 'transparent',
    },
  },
}));
//every tab change triggers a rerender of the whole component. memoized this component to avoid rendering  multiple marketo forms on same page
const MemoizedForm = memo(ContactForm);

export const ContactFormModal = memo(
  ({
    open,
    toggleOpen,
    contactForm,
    callback,
    formImages,
    location,
    pardotUrl,
    fullWidthForm = false,
    wavelytics,
    quizLogo,
    quizIntro,
  }) => {
    const classes = useStyles();

    return (
      <Modal open={open} onClose={(e) => toggleOpen(false)}>
        <>
          <IconButton
            className={classes.closeButton}
            onClick={() => toggleOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <Box className={classes.modalContent}>
            <MemoizedForm
              modal
              contactForm={contactForm}
              callback={callback}
              formImages={formImages}
              location={location}
              pardotUrl={pardotUrl}
              fullWidthForm={fullWidthForm}
              wavelytics={wavelytics}
              quizIntro={quizIntro}
              quizLogo={quizLogo}
            />
          </Box>
        </>
      </Modal>
    );
  }
);
